module.exports = __webpack_public_path__ + "img/happybrain_product3.36b055d9.jpg";